<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import RegularLineList from "@/domains/lines/views/regularLines/partials/RegularLineList"
  import SearchSelect from "@/core/components/SearchSelect"
  import DropdownSelect from "@/core/components/DropdownSelect"
  import { lowerCase } from "lodash"
  import Icon from "@/core/components/Icon"

  export default {
    components: {
      Breadcrumbs,
      RegularLineList,
      SearchSelect,
      Icon,
      DropdownSelect,
    },
    data: () => {
      return {
        title: "Linhas",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          { name: "Gestão de Linhas", path: "lines.regular.index" },
        ],
        search: "",
        filters: {
          transportadora: {
            id: 0,
            name: "Transportadora",
          },
          linha: {
            id: 0,
            nulinharamal: "Linha",
            nuextensao: "",
          },
          origem: {
            id: 0,
            nmlocalidade: "Origem",
            delocalidade: "",
          },
          destino: {
            id: 0,
            nmlocalidade: "Destino",
            delocalidade: "",
          },
          service: 0,
          situation: 1, // padrão: Ativo
        },
        serviceTypes: [
          { id: 0, name: "Todos" },
          { id: 1, name: "Rodoviário" },
          { id: 2, name: "Urbano" },
        ],
        situationTypes: [
          { id: 0, name: "Todos" },
          { id: 1, name: "Ativo" },
          { id: 2, name: "Inativo" },
        ],
        origin: { id: 0, name: "Selecione" },
        transportadorasFilter: {
          id: 0,
          name: "Transportadora",
          business_name: "Transportadora",
        },
        linhasFilter: { id: 0, nulinharamal: "Linha", nuextensao: "Ramal" },
        originFilter: {
          id: 0,
          nmlocalidade: "Origem",
          delocalidade: "",
        },
        destinyFilter: {
          id: 0,
          nmlocalidade: "Destino",
          delocalidade: "",
        },
        canEdit: false,
      }
    },
    mounted() {
      if (this.$store.state.auth.link.organization.id === 0) {
        this.canEdit = true
      }
    },
    methods: {
      capitalize(string) {
        let arrayPalavras = string.split(" ")
        let arrayPalavrasCapitalized = arrayPalavras.map((palavra) => {
          return palavra.charAt(0).toUpperCase() + lowerCase(palavra.slice(1))
        })
        return arrayPalavrasCapitalized.join(" ")
      },
      changeTransportadorasFilter(transportadora) {
        this.transportadorasFilter = {
          id: transportadora.id,
          name: this.capitalize(transportadora.business_name),
        }
        this.filters.transportadora = this.transportadorasFilter
      },
      changeLinhasFilter(linha) {
        this.linhasFilter = {
          id: linha.idlinha,
          nulinharamal: linha.nulinharamal,
          nuextensao: linha.nuextensao,
        }
        this.filters.linha = this.linhasFilter
      },
      changeOriginFilter(origin) {
        this.originFilter = {
          id: origin.idpontosecao,
          nmlocalidade: origin.nmlocalidade,
          delocalidade: origin.delocalidade,
        }
        this.filters.origem = this.originFilter
      },
      changeDestinyFilter(destiny) {
        this.destinyFilter = {
          id: destiny.idpontosecao,
          nmlocalidade: destiny.nmlocalidade,
          delocalidade: destiny.delocalidade,
        }
        this.filters.destino = this.destinyFilter
      },
      cleanFilters() {
        this.transportadorasFilter = { id: 0, name: "Transportadora" }
        this.linhasFilter = {
          id: 0,
          nulinharamal: "Linha",
          nuextensao: "Ramal",
        }
        this.originFilter = {
          id: 0,
          nmlocalidade: "Origem",
          delocalidade: "",
        }
        this.destinyFilter = {
          id: 0,
          nmlocalidade: "Destino",
          delocalidade: "",
        }
        this.filters = {
          transportadora: { id: 0, name: "Transportadora" },
          linha: { id: 0, nulinharamal: "Linha", nuextensao: "Ramal" },
          origem: {
            id: 0,
            nmlocalidade: "Origem",
            delocalidade: "",
          },
          destino: {
            id: 0,
            nmlocalidade: "Destino",
            delocalidade: "",
          },
          service: 0,
          situation: 1, // volta sempre para Ativo
        }
        this.$nextTick(() => {
          this.$refs.table.page = 1
          this.$refs.table.getLines()
        })
      },
      searchLines() {
        this.$refs.table.page = 1
        this.$refs.table.getLines()
      },
    },
  }
</script>

<template>
  <div class="w-full bg-gray-light">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5">Gestão de Linhas</h1>
        <router-link
          v-if="canEdit"
          tag="button"
          class="px-2 py-2 mb-2 form-new-green sm:py-1"
          :to="{ name: 'lines.regular.create' }"
        >
          <div class="flex items-center justify-center">
            <Icon icon="plus" class="h-4 mr-1 fill-current"/>
            Nova Linha Regular
          </div>
        </router-link>
      </div>
      <form class="p-2" @submit.prevent="searchLines">
        <h1 class="text-green-base mb-2">Filtre sua pesquisa</h1>
        <!-- Definindo padrão para responsividade do layout dos filtros e botões -->
        <div class="grid sm:grid-cols-1 lg:grid-cols-5">
          <div
            class="grid sm:col-span-5 md:col-span-5 lg:col-span-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-3 items-end"
          >
            <SearchSelect
              :selected.sync="transportadorasFilter"
              :search-keys="[]"
              :search-remote="true"
              :lazy-load="true"
              options-url="/api/registry/organizations/"
              :digits-before-search="3"
              option-key="transportadora"
              optional-placeholder-icon="icon_bus.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="organization"
              :option-value="
                                transportadora => capitalize(transportadora.name)
                            "
              @changed="changeTransportadorasFilter"
            ></SearchSelect>
            <SearchSelect
              :selected.sync="linhasFilter"
              :search-keys="[]"
              :search-remote="true"
              :lazy-load="true"
              options-url="/api/lines/route/filter/"
              :digits-before-search="1"
              option-key="linha"
              optional-placeholder-icon="icon_final_point.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="nulinharamal"
              :option-value="
                                linha =>
                                    linha.nulinharamal + ' - ' + linha.nuextensao
                            "
              @changed="changeLinhasFilter"
            ></SearchSelect>
            <SearchSelect
              :selected.sync="originFilter"
              :search-keys="[]"
              :search-remote="true"
              :lazy-load="true"
              options-url="/api/lines/section-point/search/"
              :digits-before-search="3"
              option-key="origin"
              optional-placeholder-icon="icon_flag.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="origin"
              :option-value="
                                sectionPoint =>
                                    capitalize(sectionPoint.nmlocalidade) +
                                    ' - ' +
                                    capitalize(sectionPoint.delocalidade)
                            "
              @changed="changeOriginFilter"
            ></SearchSelect>
            <SearchSelect
              :selected.sync="destinyFilter"
              :search-keys="[]"
              :search-remote="true"
              :digits-before-search="3"
              :lazy-load="true"
              options-url="/api/lines/section-point/search/"
              option-key="destiny"
              optional-placeholder-icon="icon_flag.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="origin"
              :option-value="
                                sectionPoint =>
                                    capitalize(sectionPoint.nmlocalidade) +
                                    ' - ' +
                                    capitalize(sectionPoint.delocalidade)
                            "
              @changed="changeDestinyFilter"
            ></SearchSelect>
            <div class="filter-select-wrapper">
              <label class="filter-label">Serviço</label>
              <DropdownSelect
                class="w-full custom-filter-dropdown"
                :options="
                  serviceTypes.map(st => ({
                    value: st.id,
                    label: st.name
                  }))
                "
                :selected.sync="filters.service"
              />
            </div>

            <div class="filter-select-wrapper">
              <label class="filter-label">Situação</label>
              <DropdownSelect
                class="w-full custom-filter-dropdown"
                :options="
                  situationTypes.map(st => ({
                    value: st.id,
                    label: st.name
                  }))
                "
                :selected.sync="filters.situation"
              />
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-2 items-end self-end mt-auto">
            <button
              class="flex h-8 justify-center items-center form-red text-xs uppercase"
              type="button"
              @click="cleanFilters"
            >
              Limpar
            </button>
            <button
              class="flex h-8 justify-center items-center form-submit"
              type="submit"
            >
              Pesquisar
            </button>
          </div>
        </div>
      </form>
      <div class="p-2">
        <RegularLineList
          ref="table"
          :origin="origin"
          :search="search"
          :filters="filters"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.filter-select-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
}

.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #008b5d;
  padding-left: 2px;
  line-height: 1;
  margin-bottom: 4px;
}

.custom-filter-dropdown {
  min-height: 40px;
  display: flex;
  align-items: start;
}
</style>